import {
  Box,
  Button,
  HStack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { EditSchoolModal } from '$/pages/SchoolPage/components/EditSchoolModal';
import { type User } from '$/services/usecases/authentication/mapper/genericCloudResponse';
import { type School } from '$/services/usecases/school/mapper/schools';

interface Props {
  school?: School;
  teachers?: User[];
}

export const SchoolProfileSection: FC<Props> = ({ school, teachers }) => {
  const { t } = useTranslation();
  const { hasPermission } = useAuthorization();
  const editModal = useDisclosure();

  if (!school) return null;

  const deputy = teachers?.find((t) => t.id === school.deputyId);

  return (
    <Box
      w='full'
      p='4'
      border='1px solid'
      borderColor='border'
      borderRadius='md'
    >
      <HStack align='start' justify='space-between' gap='4'>
        <VStack align='stretch' gap='0'>
          <Text fontSize='sm'>
            {t('school.registerSchool.form.fullAddress')}: {school.address}
          </Text>
          <Text fontSize='sm'>
            {t('school.registerSchool.form.website')}: {school.website}
          </Text>
          <Text fontSize='sm'>
            {t('school.registerSchool.form.phone')}: {school.phone}
          </Text>
          <Text fontSize='sm'>
            {t('school.profile.deputy')}:{' '}
            {deputy ? `${deputy.firstname} ${deputy.lastname}` : '-'}
          </Text>
        </VStack>

        {hasPermission('School_Manage_Profile') && (
          <HStack flexWrap='wrap' gap='2'>
            <Button onClick={editModal.onOpen} size='sm' variant='secondary'>
              {t('school.profile.edit')}
            </Button>
          </HStack>
        )}
      </HStack>

      <EditSchoolModal
        school={school}
        isOpen={editModal.isOpen}
        onClose={editModal.onClose}
      />
    </Box>
  );
};
